import React from 'react';
import propTypes from '../../../node_modules/prop-types/index.js';
import safeCustomStyle from '../../utils/safeCustomStyle.js';
import { CardContentWrapper } from './styledComponents.js';

var CardContent = function CardContent(_ref) {
  var isScrollable = _ref.isScrollable,
      scrollSectionHeight = _ref.scrollSectionHeight,
      children = _ref.children,
      customStyle = _ref.customStyle;

  var _safeCustomStyle = safeCustomStyle(customStyle),
      contentStyle = _safeCustomStyle.contentStyle;

  return /*#__PURE__*/React.createElement(CardContentWrapper, {
    isScrollable: isScrollable,
    scrollSectionHeight: scrollSectionHeight,
    contentStyle: contentStyle
  }, children);
};

process.env.NODE_ENV !== "production" ? CardContent.propTypes = {
  /** flag for making the content area scrollable */
  isScrollable: propTypes.bool,

  /** height of the scrollable section */
  scrollSectionHeight: propTypes.string,

  /** Style overrides */
  customStyle: propTypes.shape({
    contentStyle: propTypes.object
  }),

  /** children */
  children: propTypes.node.isRequired
} : void 0;
CardContent.defaultProps = {
  isScrollable: false,
  scrollSectionHeight: '100px',
  customStyle: {
    contentStyle: {}
  }
};
process.env.NODE_ENV !== "production" ? CardContent.displayName = 'CardContent' : void 0;

export default CardContent;
